import { render, staticRenderFns } from "./PopularPosts.vue?vue&type=template&id=33281316&scoped=true&"
import script from "./PopularPosts.vue?vue&type=script&lang=js&"
export * from "./PopularPosts.vue?vue&type=script&lang=js&"
import style0 from "./PopularPosts.vue?vue&type=style&index=0&id=33281316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33281316",
  null
  
)

export default component.exports